import http from '@/api/common'

export default {
  saveScanProConfiguration(data) {
    return http.post('scanpro/SaveScanProConfiguration', data)
  },
  getScanProConfiguration(id) {
    return http.get(`scanpro/ScanProConfiguration?id=${id}`)
  },
  decodeVin(vin) {
    return http.get(`decoder/DecodeVin?vin=${vin}`)
  },
  evaluateVehicle(data) {
    return http.post('scanpro/EvaluateVehicle', data)
  },
  saveScanProResults(data) {
    return http.post('scanpro/SaveScanProResults', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/scanpro.js